import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import App from './App';

const scroll = () => {
  console.log('scroll')
}

ReactDOM.render(
  <React.StrictMode>
    <App onScroll={scroll}/>
  </React.StrictMode>,
  document.getElementById('root')
);